import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const experienceData = [
    {
        id: 1,
        title: 'ShopUp',
        description: 'Now I am working at Customer Experience Associate at ShopUp company',
        date: 'Since 2021'
    }, {
        id: 2,
        title: 'Genex Infosys Limited',
        description: 'Here I worked as a Customer Service Associate.',
        date: '2019 - 2021'
    }, {
        id: 3,
        title: 'Intelligent Image Management Limited',
        description: 'Here I worked as a Data Entry Operator',
        date: '2017 - 2019'
    }
]

const Experience = () => {
    return (
        <div className="experience padd-15">
            <h3 className="title">Experience</h3>
            <div className="row">
                <div className="timeline-box padd-15">
                    <div className="timeline shadow-dark">
                        {
                            experienceData.map(experience => <div key={experience.id} className="timeline-item">
                                <div className="circle-dot"></div>
                                <h6 className="timeline-date"><FontAwesomeIcon icon={faCalendarAlt} /> {experience.date}</h6>
                                <h4 className="timeline-title">{experience.title}</h4>
                                <p className="timeline-text">{experience.description}</p>
                            </div>)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Experience;